<div class="version-status-update-menu-status-list" [hidden]="status.length==0">
    <ul>
      <li *ngFor="let st of status">
        <span (click)="onClick(st)" [style.background-color]="st.color ? st.color :''">{{st.name}}</span>  
      </li>
    </ul>
</div>
